import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';
import {
  ChallengesContainer,
  ChallengeDetailsConatainer,
  ChallengeHeading,
  ImageLayout,
  DateLocationContainer,
} from '../../UserDashboard/styles';
import { TabViewNew } from '../../ChallengeDetailsV2/styles';
import {
  LeaderboardContainer,
  LeaderboardHeader,
  LeaderboardRow,
  UserColumn,
  AnswerColumn,
  ScrollContainer
} from '../../ChallengeDetailsV2/ChallengeLeaderboardV2/styles';
import HoverButton from '../../common/HoverButton';
import { fetchApi, getInitials } from '../../../utils/methods';
import { ImageUrl } from '../../../utils/constants';
import { EditIconBranding, NewWarningIcon, CalendarChallengeIcon, RewardsChallengeIcon, BackArrowFeed, NewArchiveIcon } from '../../../utils/icons';
import { CommonButtonPopup, CommonButtonBorder } from '../../HealthCoach/styles';
import ActiveInitiativeCard from '../../HealthDataManagement/ActiveInitiativeCard';
import CustomNotification from '../../ChallengeDetailsV2/customNotification';
import CSVList from '../../AttendeesModal/CSVList';
import { NameInitials } from '../../Manager/styles';
import {
  GetCompanyInitiativeDetailsById,
  ArchiveCompanyInitiative,
  GetInitiativesReportV2,
} from '../../../redux/constants/apiConstants';
import {
  InitiativeLeftContainer,
  InitiativeAboutSection,
  InitiativeDivider,
  InitiativeRightWrapper,
  ParticipantsHeader,
  ParticipantsCount,
  UserAvatar,
} from './styles';
import LazyImage from '../../common/LazyImage/LazyImage';
import SkeletonLoder from '../../common/skeletonLoder';
import CommonModalNew from '../../common/CommonModal/CommonModalNew';
import dayjs from 'dayjs';

const CSV_HEADERS = [
  { label: 'First Name', key: 'fname' },
  { label: 'Last Name', key: 'lname' },
  { label: 'Email', key: 'mail' },
  { label: 'Completed On', key: 'completed_on' },
];

const InitiativeDetailsPage = ({ history, match }) => {
  const id = match?.params?.id;
  const fromLibrary = history?.location?.state?.fromLibrary || false;


  const [activeTab, setActiveTab] = useState('initiative');
  const [initiative, setInitiative] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [totalParticipants, setTotalParticipants] = useState(0);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [printCSV, setPrintCSV] = useState(false);
  const [csvData, setCsvData] = useState([]);

  // const isCompleted = !!initiative?.completion;

  const isCompleted = dayjs().isAfter(dayjs(initiative?.end_date));

  const fetchDetails = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    try {
      const res = await fetchApi(
        `${GetCompanyInitiativeDetailsById}?id=${id}`,
        'GET'
      );
      if (res.status === 'success') {
        setInitiative(res.data?.[0] || res.data);
      } else {
        toast.error(res.message || 'Failed to fetch initiative details');
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  }, [id]);

  const fetchParticipants = useCallback(async (pageNum = 1) => {
    if (!id) return;
    try {
      const res = await fetchApi(
        `${GetInitiativesReportV2}?company_initiative_id=${id}&page=${pageNum}&limit=20`,
        'GET'
      );
      if (res.status === 'success') {
        const list = res?.data?.participants || [];
        setParticipants((prev) => (pageNum === 1 ? list : [...prev, ...list]));
        if (pageNum === 1) {
          setTotalParticipants(res?.data?.participants_count);
        }
        setHasMore(list.length === 20);
        setPage(pageNum);
      }
    } catch (err) {
      toast.error(err.message);
    }
  }, [id]);

  useEffect(() => {
    fetchDetails();
  }, [id]);

  const handleTabSwitch = (tab) => {
    if (activeTab === tab) return;
    setActiveTab(tab);
    if (tab === 'participants') fetchParticipants(1);
  };

  const handleScroll = (e) => {
    const diff =
      Math.round(e.target.scrollHeight - e.target.scrollTop) -
      Math.round(e.target.clientHeight);
    if ((diff === 0 || diff === 1) && hasMore) {
      fetchParticipants(page + 1);
    }
  };

  const handleArchive = async () => {
    try {
      const res = await fetchApi(ArchiveCompanyInitiative, 'DELETE', {
        company_initiative_id: id,
      });
      if (res.status === 'success') {
        toast.success('Initiative archived successfully');
        history.goBack();
      } else {
        toast.error(res.message || 'Failed to archive initiative');
      }
    } catch (err) {
      toast.error(err.message);
    }
    setShowArchiveModal(false);
  };

  const downloadReport = async () => {
    try {
      const res = await fetchApi(`${GetInitiativesReportV2}?company_initiative_id=${id}`, 'GET');
      if (res.status === 'success') {
        const data = res?.data?.participants || res?.data || [];
        setCsvData(data);
        setPrintCSV(true);
      } else {
        toast.error(res.message || 'Failed to download report');
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const renderLeftInitiative = () => (
    <InitiativeLeftContainer>
      <ImageLayout>
        <LazyImage
          src={`${ImageUrl}/${initiative?.thumbnail || initiative?.initiative_image}`}
          alt="Initiative banner"
          style={{ width: '100%', height: '472px', borderRadius: '6px' }}
        />
      </ImageLayout>
      <InitiativeDivider />
      {(initiative?.about || initiative?.description) ? (
        <InitiativeAboutSection>
          <div className="heading">About</div>
          <div
            className="body"
            dangerouslySetInnerHTML={{ __html: initiative?.about || initiative?.description }}
          />
          {/* <InitiativeDivider /> */}
        </InitiativeAboutSection>
      ):null}
      <DateLocationContainer>
        {initiative?.start_date ? (
          <div className="insideBox">
            {CalendarChallengeIcon()}
            <div className="text">
              {moment(initiative.start_date).format('MMM DD')}
              {initiative?.end_date
                ? ` - ${moment(initiative.end_date).format('MMM DD, YYYY')}`
                : ''}
            </div>
          </div>
        ):null}
        <div className="rewardBox" style={{ marginTop: 0 }}>
          {RewardsChallengeIcon()}
          <div className="rewardValue">+{initiative.point_value || 0} Health Hub points</div>
        </div>
      </DateLocationContainer>
    </InitiativeLeftContainer>
  );

  const renderLeftParticipants = () => (
    <InitiativeLeftContainer>
      <LeaderboardContainer>
        <div className="header">
          <ParticipantsHeader>
            <div
              className="icon-wrap"
              style={{ background: initiative?.color || '#BE7D9C' }}
            >
              <img src={`${ImageUrl}/${initiative?.initiative_white_icon}`} alt="" />
            </div>
            <span className="title">Participants</span>
          </ParticipantsHeader>
          <ParticipantsCount>
            {totalParticipants || 0}
          </ParticipantsCount>
        </div>

        <LeaderboardHeader>
          <UserColumn>Users</UserColumn>
          <AnswerColumn>Completion Date</AnswerColumn>
        </LeaderboardHeader>

        <ScrollContainer  onScroll={handleScroll}>
          {participants.length > 0 ? (
            participants.map((p, i) => (
              <LeaderboardRow key={i}>
                <UserColumn>
                  {p.profile_image && !p.profile_image.includes('default.png') ? (
                    <UserAvatar src={`${ImageUrl}/${p.profile_image}`} alt="" />
                  ) : (
                    <NameInitials isWidth="36px" isHeight="36px" isSize="12px" margin="0 8px 0 0">
                      {getInitials(p.user_name || `${p.fname || ''} ${p.lname || ''}`)}
                    </NameInitials>
                  )}
                  <span>{p.user_name || `${p.fname || ''} ${p.lname || ''}`}</span>
                </UserColumn>
                <AnswerColumn>
                  {p.completed_on ? moment(p.completed_on).format('MMM DD, YYYY') : '—'}
                </AnswerColumn>
              </LeaderboardRow>
            ))
          ) : (
            <LeaderboardRow>
              <UserColumn style={{ justifyContent: 'center', width: '100%' }}>
                No participants yet
              </UserColumn>
            </LeaderboardRow>
          )}
        </ScrollContainer>
      </LeaderboardContainer>
    </InitiativeLeftContainer>
  );

  const renderRightContainer = () => (
    <InitiativeRightWrapper>
      <ActiveInitiativeCard details={initiative} hideBell fullWidth />
      {isCompleted ? (
        <CommonButtonBorder
          width="100%"
          style={{ justifyContent: 'center', cursor: 'pointer', marginTop: '16px' }}
          onClick={downloadReport}
        >
          Print Report
        </CommonButtonBorder>
      ) : (
        <CommonButtonPopup
          background="#DA6C74"
          width="100%"
          style={{ marginTop: '16px' }}
          onClick={() => setShowNotification(true)}
        >
          Send Custom Notification
        </CommonButtonPopup>
      )}
    </InitiativeRightWrapper>
  );

  if (loading) return (
    <div style={{ maxWidth: '1248px', padding: '24px 0 40px 0', margin: 'auto', width: '100%' }}>
      <SkeletonLoder width="100%" height="44px" style={{ borderRadius: '8px', marginBottom: '16px' }} />
      <SkeletonLoder width="340px" height="32px" style={{ borderRadius: '6px', marginBottom: '20px' }} />
      <div style={{ display: 'flex', gap: '20px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: '16px' }}>
          <SkeletonLoder width="100%" height="472px" style={{ borderRadius: '8px' }} />
          <SkeletonLoder width="100%" height="16px" style={{ borderRadius: '4px' }} />
          <SkeletonLoder width="80%" height="16px" style={{ borderRadius: '4px' }} />
          <SkeletonLoder width="60%" height="16px" style={{ borderRadius: '4px' }} />
          <div style={{ display: 'flex', gap: '24px', marginTop: '8px' }}>
            <SkeletonLoder width="140px" height="40px" style={{ borderRadius: '6px' }} />
            <SkeletonLoder width="140px" height="40px" style={{ borderRadius: '6px' }} />
          </div>
        </div>
        <div style={{ width: '436px', flexShrink: 0, display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <SkeletonLoder width="100%" height="220px" style={{ borderRadius: '12px' }} />
          <SkeletonLoder width="100%" height="48px" style={{ borderRadius: '8px' }} />
        </div>
      </div>
    </div>
  );
 


  return (
    <div style={{ maxWidth: '1248px', padding: '24px 0 40px 0', margin: 'auto', width: '100%' }}>
      <ChallengesContainer>
        <div className="right-row">
          <div className="icon" onClick={() => history.push({pathname: '/company/health',  state: fromLibrary ? "library" : "dashboard"})}>
            {BackArrowFeed('#DA6C74')}
          </div>
          <TabViewNew
            width
            padding
            margin="0 16px 0 0"
            height="40px"
            active={activeTab === 'initiative' ? 1 : 0}
            onClick={() => handleTabSwitch('initiative')}
          >
            Initiative
          </TabViewNew>
          <TabViewNew
            width
            padding
            margin="0 16px 0 0"
            height="40px"
            active={activeTab === 'participants' ? 1 : 0}
            onClick={() => handleTabSwitch('participants')}
          >
            Participants
          </TabViewNew>
        </div>
        {!isCompleted && (
          <div className="action-icons">
            <HoverButton
              title="Edit Initiative"
              svgPath={<EditIconBranding />}
              activeColor="#DA6C74"
              inActiveColor="#DA6C74"
              backgroundColor="white"
              backgroundColorActive="#DA6C74"
              width="20px"
              height="20px"
              fillOpacity={1}
              onClick={() =>
                history.push({
                  pathname: '/company/edit-initiative',
                  state: { initiativeData: initiative },
                })
              }
            />
            <HoverButton
              title="Archive Initiative"
              svgPath={<NewArchiveIcon />}
              activeColor="#DA6C74"
              inActiveColor="#DA6C74"
              backgroundColor="white"
              backgroundColorActive="#DA6C74"
              width="20px"
              height="20px"
              fillOpacity={1}
              onClick={() => setShowArchiveModal(true)}
            />
          </div>
        )}
      </ChallengesContainer>

      <ChallengeHeading>{initiative?.initiative_name}</ChallengeHeading>

      <ChallengeDetailsConatainer>
        <div className="insideConatainer">
          <div className="leftContainer">
            {activeTab === 'initiative' ? renderLeftInitiative() : renderLeftParticipants()}
          </div>
          {renderRightContainer()}
        </div>
      </ChallengeDetailsConatainer>

      {showArchiveModal && (
        <CommonModalNew
          show={showArchiveModal}
          modalWidth={"400px"}
          title="Archive Initiative"
          description="Are you sure you want to archive this initiative?"
          subDescription="Archiving will remove it from active programs and dashboards, but all associated data will be safely retained for reporting and historical records."
          onCancel={() => setShowArchiveModal(false)}
          descriptionColor="#CE7841"
          onConfirm={handleArchive}
          cancelText="Keep Initiative"
          confirmButtonText="Archive Initiative"
          icon={NewWarningIcon('#CE7841')}
          cancelButtonWidth={"150px"}
          confirmButtonWidth={"180px"}
          buttonIcon={<></>}
        />
      )}

      {showNotification && (
        <CustomNotification
          showModal={showNotification}
          onClose={() => setShowNotification(false)}
          type="initiative"
          companyInitiativeId={id}
          companyId={initiative?.company_id}
        />
      )}

      {printCSV && (
        <CSVList
          Title="initiative_participants_report"
          data={csvData}
          headers={CSV_HEADERS}
          removeCSVData={() => {
            setPrintCSV(false);
            setCsvData([]);
          }}
        />
      )}
    </div>
  );
};

InitiativeDetailsPage.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default connect(null, null)(InitiativeDetailsPage);
